import { useEffect, useState } from "react";

const useMediaQuery = (query: string) => {
  const [matches, setMatches] = useState(window.matchMedia(query).matches);

  useEffect(() => {
    let media = window.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }
    let listener = () => setMatches(media.matches);
    if (media && "addEventListener" in media) {
      media.addEventListener("change", listener);
    }
    return () => {
      if (media && "removeEventListener" in media) {
        media.removeEventListener("change", listener);
      }
    };
  }, [matches, query]);

  return matches;
};

export default useMediaQuery;
